import { render, staticRenderFns } from "./ManageStudentDashboard.vue?vue&type=template&id=bb4c2672&"
import script from "./ManageStudentDashboard.vue?vue&type=script&lang=js&"
export * from "./ManageStudentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports